/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Alter_SeatingInputs */



/**
* | output |
* | --- |
* | "Alter seating" |
*
* @param {Rounds_Alter_SeatingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_alter_seating = /** @type {((inputs?: Rounds_Alter_SeatingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Alter_SeatingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier le placement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Modificar asientos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Alterar assentos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifica posti")
	return /** @type {LocalizedString} */ ("Alter seating")
});